import { request } from "./request";

const BASE_URL = "/api/immigration_office";

export default {
  async fetch(city) {
    return await request(`${BASE_URL}/${city}`);
  },
};
